import React from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { Close, DownloadForOffline } from "@mui/icons-material";

const ImageCacheDialog = () => {
  const [cached, setCached] = React.useState(
    Boolean(localStorage.getItem("img-cached"))
  );
  const [caching, setCaching] = React.useState(false);

  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  if (cached || !window.caches) {
    return null;
  }

  return (
    <>
      <Tooltip title="Cache All Images for Offline">
        <IconButton
          color="inherit"
          size="small"
          disabled={caching}
          onClick={() => {
            setOpen(true);
          }}
        >
          {caching ? (
            <CircularProgress color="inherit" size="20px" />
          ) : (
            <DownloadForOffline />
          )}
        </IconButton>
      </Tooltip>

      <Dialog onClose={handleClose} open={open}>
        <DialogTitle>
          <Stack spacing={1} direction="row" width="100%" alignItems="center">
            <Typography width="100%" variant="h6" fontWeight="bold">
              Cache All Images for Offline
            </Typography>
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </Stack>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Typography>
            Are you sure you want to cache all images for offline use? This will
            take a while and use a some of storage space.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              handleClose();
              caches.open("images").then((cache) => {
                setCaching(true);
                return cache
                  .addAll(imgs)
                  .then(() => {
                    console.log("Image cache complete");
                    setCached(true);
                    localStorage.setItem("img-cached", "true");
                  })
                  .catch((err) => {
                    alert("Something wrong while caching images");
                    console.log(err);
                  })
                  .finally(() => {
                    setCaching(false);
                  });
              });
            }}
          >
            Confirm
          </Button>
          <Button color="inherit" onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const imgs = [
  "hydrogen",
  "helium",
  "lithium",
  "beryllium",
  "boron",
  "carbon",
  "nitrogen",
  "oxygen",
  "fluorine",
  "neon",
  "sodium",
  "magnesium",
  "aluminum",
  "silicon",
  "phosphorus",
  "sulfur",
  "chlorine",
  "argon",
  "potassium",
  "calcium",
  "scandium",
  "titanium",
  "vanadium",
  "chromium",
  "manganese",
  "iron",
  "cobalt",
  "nickel",
  "copper",
  "zinc",
  "gallium",
  "germanium",
  "arsenic",
  "selenium",
  "bromine",
  "krypton",
  "rubidium",
  "strontium",
  "yttrium",
  "zirconium",
  "niobium",
  "molybdenum",
  "technetium",
  "ruthenium",
  "rhodium",
  "palladium",
  "silver",
  "cadmium",
  "indium",
  "tin",
  "antimony",
  "tellurium",
  "iodine",
  "xenon",
  "cesium",
  "barium",
  "lanthanum",
  "cerium",
  "praseodymium",
  "neodymium",
  "promethium",
  "samarium",
  "europium",
  "gadolinium",
  "terbium",
  "dysprosium",
  "holmium",
  "erbium",
  "thulium",
  "ytterbium",
  "lutetium",
  "hafnium",
  "tantalum",
  "tungsten",
  "rhenium",
  "osmium",
  "iridium",
  "platinum",
  "gold",
  "mercury",
  "thallium",
  "lead",
  "bismuth",
  "polonium",
  "astatine",
  "radon",
  "francium",
  "radium",
  "actinium",
  "thorium",
  "protactinium",
  "uranium",
  "neptunium",
  "plutonium",
  "americium",
  "curium",
  "berkelium",
  "californium",
  "einsteinium",
  "fermium",
  "mendelevium",
  "nobelium",
  "lawrencium",
  "rutherfordium",
  "dubnium",
  "seaborgium",
  "bohrium",
  "hassium",
  "meitnerium",
  "darmstadtium",
  "roentgenium",
  "copernicium",
  "nihonium",
  "flerovium",
  "moscovium",
  "livermorium",
  "tennessine",
  "oganesson",
  "neutron",
].map((el) => `/elements/${el}.jpg`);

export default ImageCacheDialog;
